module.exports = "/assets/data/7b30a6e598a4d33714652108f900bf7e-SM3.data.json";